import React from 'react';
import { Link } from 'react-router-dom';
type Props = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  inverted?: boolean;
};
const SIZES = {
  sm: {
    word: 'text-[18px]',
    unit: 'text-[10px]',
    offset: 'mt-[2px]'
  },
  md: {
    word: 'text-[22px]',
    unit: 'text-[12px]',
    offset: 'mt-[3px]'
  },
  lg: {
    word: 'text-[26px]',
    unit: 'text-[14px]',
    offset: 'mt-[4px]'
  }
};
export function Logo({
  className = '',
  size = 'md',
  inverted = false
}: Props) {
  const s = SIZES[size];
  const wordColor = inverted ? 'text-background' : 'text-foreground';
  return <Link to="/" className={`inline-flex items-start group ${className}`} aria-label="peptides.ml home" data-id="element-378">
      <span className={`${s.word} font-semibold tracking-[-0.02em] leading-none ${wordColor}`} data-id="element-379">
        peptides
      </span>
      <span className={`${s.unit} ${s.offset} font-semibold tracking-[0.01em] leading-none ml-[2px] text-primary`} data-id="element-380">
        .ml
      </span>
    </Link>;
}